export default __webpack_public_path__ + "static/media/bell-icon.c3af7cf6.svg";